import React from 'react';
import { steps } from '../data/content';
const TREATMENT_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/46871c1f-32c9-4bf4-997f-65b4aabd45c7.jpg';
export function Process() {
  return <section id="process" className="w-full bg-ash-50 py-20 lg:py-28" data-id="element-124" data-mp="1yeyt5y2goz4d">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-8" data-id="element-125" data-mp="23ebak3akddzk">
        <div className="max-w-2xl" data-id="element-126" data-mp="23difhzkywcx9">
          <h2 className="font-display text-4xl leading-tight tracking-tight text-ash-900 lg:text-5xl" data-id="element-127" data-mp="16o0xqm8pn0f7">
            From first question to final result
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ash-600" data-id="element-128" data-mp="1apvzfrujzfti">
            Four steps, one appointment, and a result that arrives quietly enough that people notice you — not the
            treatment.
          </p>
        </div>

        <div className="mt-14 grid gap-12 lg:grid-cols-[1fr_0.85fr] lg:items-center lg:gap-20" data-id="element-129" data-mp="n0bfp6qksej6">
          <ol className="relative" data-id="element-130" data-mp="rz4rmuq7rxh8">
            {steps.map((step, index) => <li key={step.title} className="relative flex gap-6 pb-10 last:pb-0" data-id="element-131" data-mp="rws3u0xrysw9" data-mpi={index}>
                {index < steps.length - 1 && <span className="absolute left-[19px] top-11 bottom-0 w-px bg-ash-300" aria-hidden="true" data-id="element-132" data-mp="15j48gswgybma" />}
                <span className="relative z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-royal-600 text-sm font-bold text-white" data-id="element-133" data-mp="vu2qwya9zm67">
                  {index + 1}
                </span>
                <div className="pt-1" data-id="element-134" data-mp="lv57g9rpiiu2">
                  <h3 className="text-xl font-semibold tracking-tight text-ash-900" data-id="element-135" data-mp="lu3jj4ple1ux">{step.title}</h3>
                  <p className="mt-2 max-w-lg text-[15px] leading-relaxed text-ash-600" data-id="element-136" data-mp="hul8d0nkp55a">{step.body}</p>
                </div>
              </li>)}
          </ol>

          <figure className="overflow-hidden rounded-3xl" data-id="element-137" data-mp="2c8chlz1zpn07">
            <img src={TREATMENT_IMAGE} alt="Clinician performing a non-invasive ultrasound treatment on a patient's jawline" className="aspect-[3/2] w-full object-cover lg:aspect-[4/5]" data-id="element-138" data-mp="2c5q6jpfw4pd8" />
            <figcaption className="mt-3 text-xs text-ash-500" data-id="element-139" data-mp="2v5cxnxbetgqy">
              Treatments are performed only by trained, certified providers.
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}